import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import LayoutModal from "../../../LayoutModal";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Interface
import { ICreate } from "Interfaces/ICreate";
import { IExpense, Inputs } from "Interfaces/IExpense";

export default function CreateExpenses({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<Inputs>();

  const UserAuthenticated = useAuth();
  const [category, setCategory] = useState<IExpense["category_expenses"][]>([]);
  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get('category-expense');
      setCategory(response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModal) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = {
        ...data,
        user_id: UserAuthenticated.user?.id,
        title: data.title.toUpperCase(),
      }
      const response = await apiRequest(`expense`, 'POST', payload);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Saída"
        subTitle="Cadastre uma nova saída em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}

        nameIconMinimize={'Registrar Saída'}
        setMaximizeModal={fetchData}
      >
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o nome da saída"
              type="text"
              {...register("title", { required: true })}
            />
            {errors.title && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>

          <S.FormInput>
            <S.Label>
              Categoria
              <span>*</span>
            </S.Label>
            <S.Select {...register("category_expense_id", { required: true })}>
              <option value="" disabled selected hidden>
                Selecione
              </option>
              {category.map((val) => {
                return <option value={val.id}>{val.category_expense}</option>;
              })}
            </S.Select>
            {errors.category_expense_id && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Valor
                <span>*</span>
              </S.Label>
              <Controller
                name="total_amount"
                control={control}
                rules={{ required: "Este campo é obrigatório" }}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="R$ 0,00"
                    prefix="R$ "
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue); // Atualiza o valor de compra
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.total_amount && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Data
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe a ponta"
                type="date"
                {...register("date_proof", { required: true })}
              />
              {errors.date_proof && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.SeparateDiv>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
